import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { PaginatedResultModel, PaginationSearchModel } from '@data-layer/models/common';
import { ManagementContainerModel, ManagementContainerSealModel, ManagementUpdateContainerModel } from '@data-layer/models/management';

@Injectable({
  providedIn: 'root',
})
export class ContainerSealsRepository {
  constructor(private apiService: ApiService) {}

  public search(params?: PaginationSearchModel, isShowLoader?: boolean): Observable<PaginatedResultModel<ManagementContainerSealModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementContainerSealModel>>(
      environment.url.freight.containerSealsManagement,
      { params },
      { isShowLoader },
    );
  }

  public searchByContainerId(
    containerId: ManagementContainerModel['id'],
    params: PaginationSearchModel,
    isShowLoader?: boolean,
  ): Observable<PaginatedResultModel<ManagementContainerSealModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementContainerSealModel>>(
      `${environment.url.freight.containersManagement}/${containerId}/seals`,
      { params },
      {
        isShowLoader,
      },
    );
  }

  public create(
    containerId: ManagementContainerModel['id'],
    model: ManagementUpdateContainerModel,
    isShowLoader?: boolean,
  ): Observable<ManagementContainerSealModel> {
    return this.apiService.post<ManagementContainerSealModel>(
      `${environment.url.freight.containersManagement}/${containerId}/seals`,
      model,
      null,
      {
        isShowLoader,
      },
    );
  }

  public get(id: ManagementContainerSealModel['id'], isShowLoader?: boolean): Observable<ManagementContainerSealModel> {
    return this.apiService.get<ManagementContainerSealModel>(`${environment.url.freight.containerSealsManagement}/${id}`, null, {
      isShowLoader,
    });
  }

  public update(
    id: ManagementContainerSealModel['id'],
    model: ManagementUpdateContainerModel,
    isShowLoader?: boolean,
  ): Observable<ManagementContainerSealModel> {
    return this.apiService.put<ManagementContainerSealModel>(`${environment.url.freight.containerSealsManagement}/${id}`, model, null, {
      isShowLoader,
    });
  }

  public delete(id: ManagementContainerSealModel['id'], isShowLoader?: boolean): Observable<never> {
    return this.apiService.delete(`${environment.url.freight.containerSealsManagement}/${id}`, null, { isShowLoader });
  }
}
